export default __webpack_public_path__ + "static/media/lang.7eb3e082.svg";